import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API_URLS from "../../summaryapi/apiUrls"; // adjust path based on your folder structure

const Dashboard = () => {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({
    total_employees: 0,
    total_students: 0,
    today_students: 0,
  });

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem("isAuthenticated");
    const isAdmin = sessionStorage.getItem("isAdmin") === "true";

    if (!isAuthenticated) {
      navigate("/");
    } else if (!isAdmin) {
      navigate("/student-enrollment");
    }
  }, [navigate]);

  useEffect(() => {
    const fetchDashboardCounts = async () => {
      try {
        const response = await fetch(API_URLS.getdashboardcount.url, {
          method: API_URLS.getdashboardcount.method,
        });
        const data = await response.json();
        if (data.status) {
          setCounts(data.data);
        } else {
          console.error("Failed to fetch dashboard counts");
        }
      } catch (error) {
        console.error("Error fetching dashboard counts:", error);
      }
    };

    fetchDashboardCounts();
  }, []);

  const stats = [
    {
      title: "Total Voluntaries",
      value: counts.total_employees,
      color: "bg-blue-500",
    },
    {
      title: "Total Students",
      value: counts.total_students,
      color: "bg-green-500",
    },
    {
      title: "Today’s Students",
      value: counts.today_students,
      color: "bg-yellow-500",
    },
    {
      title: "Create Voluntary",
      value: counts.total_employees,
      color: "bg-red-500",
      navigateTo: "/employee-information",
    },
  ];

  return (
    <div className="space-y-6 min-h-screen flex flex-col justify-between">
      <div>
        <h1 className="text-2xl font-bold text-gray-800 mb-4 ml-11 lg:ml-0">Dashboard Overview</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => {
            const box = (
              <div
                key={index}
                className={`${stat.color} p-6 rounded-lg shadow-md text-white cursor-pointer`}
                onClick={() => stat.navigateTo && navigate(stat.navigateTo)}
              >
                <h3 className="text-lg font-semibold">{stat.title}</h3>
                {stat.value !== undefined && (
                  <p className="text-3xl font-bold mt-2">{stat.value}</p>
                )}
              </div>
            );

            return stat.navigateTo ? (
              <div key={index}>{box}</div>
            ) : (
              <div key={index}>{box}</div>
            );
          })}
        </div>

      </div>

      {/* Footer */}
      <p className="text-center  text-gray-600 text-sm">
        Developed © 2025 by{" "}
        <Link
          to="https://oakyaitservices.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 hover:underline"
        >
          Oakya IT Services
        </Link>
      </p>
    </div>
  );
};

export default Dashboard;
